import { render, staticRenderFns } from "./ProfileMenuLink.vue?vue&type=template&id=c1bd2a98&"
import script from "./ProfileMenuLink.vue?vue&type=script&lang=js&"
export * from "./ProfileMenuLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports